import classNames from "classnames";
import React, { useMemo } from "react";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";

import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";

type Props = {
  name: string;
  value: string | number | undefined;
  options: any[];
  onChange?: (value: string) => void;
  containerClasses?: any;
  isDisabled?: boolean;
  btnClasses?: any;
  formType?: "ITR" | "GENERAL";
};

const RadioButtonGroup: React.FC<Props> = (props: Props) => {
  const {
    name,
    value,
    options,
    onChange,
    containerClasses,
    isDisabled = false,
    btnClasses = "btn-w-100",
    formType = "ITR"
  } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const isFieldDisabled = useMemo(() => {
    if (formType === "GENERAL") {
      if (isDisabled) {
        return isDisabled;
      }
      return false;
    }
    if (isFilingReadOnly) {
      return true;
    }
    return isDisabled;
  }, [isDisabled, isFilingReadOnly, formType]);

  return (
    <ToggleButtonGroup
      type="radio"
      name={name}
      value={value}
      onChange={(value) => (onChange ? onChange(value) : null)}
      className={classNames("rb-group-control", containerClasses)}
    >
      {options.map((option, index) => {
        return (
          <ToggleButton
            key={`option-${name}-${index}`}
            variant="outline-primary"
            id={`${name}-${option.value}`}
            value={option.value}
            className={classNames("btn-h-40", btnClasses)}
            disabled={isFieldDisabled}
          >
            {option.label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default RadioButtonGroup;
